import React, { FC } from "react";

const NotProvided: FC = () => {
  return <span className="text-secondary"><i>{'<not provided>'}</i></span>;
};

export default NotProvided;